import React from "react";
import LoadableComponent from "../../shared/Loading/LoadableComponent";
import Navigator from "../../shared/Navigator";
import { AccountDepositDefinition } from "../../models/AccountDepositDefinition";
import { Grid } from "@material-ui/core";
import AccDefinitionBtnSet from "./AccDefinitionBtnSet";
import getId from "../../utils/getId";
import { useDispatch } from "react-redux";
import { setErrors } from "../../store/alerts/alertsActions";
import Hidden from "@material-ui/core/Hidden";

const styleContainer = { padding: "2%" };

interface IProps {
  activeStep: number;
  lengthStepper: number;
  loading: boolean;
  setActiveStep: (value: number) => void;
  accountDepositDef: AccountDepositDefinition[];
  selectAccDepositDef: AccountDepositDefinition | null;
  setSelectAccDepositDef: (value: AccountDepositDefinition | null) => void;
}

const AccountDefinitionView: React.FC<IProps> = ({
  activeStep,
  lengthStepper,
  loading,
  setActiveStep,
  accountDepositDef,
  selectAccDepositDef,
  setSelectAccDepositDef,
}: IProps) => {
  const dispatch = useDispatch();

  const handleClickNext = () => {
    if (selectAccDepositDef) {
      setActiveStep(activeStep + 1);
    } else {
      dispatch(setErrors(["Wybierz kwotę doładowania"]));
    }
  };

  return (
    <React.Fragment>
      <LoadableComponent loading={loading}>
        <div style={styleContainer}>
          <Grid container spacing={2}>
            {accountDepositDef.map((item, index) => (
              <React.Fragment key={index}>
                <Hidden mdDown>
                  <Grid key={index} item xs={3}>
                    <AccDefinitionBtnSet
                      ticket={item}
                      onBtnClick={setSelectAccDepositDef}
                      isSelect={getId(item) === getId(selectAccDepositDef)}
                    />
                  </Grid>
                </Hidden>
                <Hidden lgUp>
                  <Grid key={index} item xs={3}>
                    <AccDefinitionBtnSet
                      ticket={item}
                      onBtnClick={setSelectAccDepositDef}
                      isSelect={getId(item) === getId(selectAccDepositDef)}
                    />
                  </Grid>
                </Hidden>
              </React.Fragment>
            ))}
          </Grid>
        </div>
      </LoadableComponent>

      <Navigator
        lengthStepper={lengthStepper}
        activeStep={activeStep}
        onClickNext={() => handleClickNext()}
        onClickPrev={() => setActiveStep(activeStep - 1)}
      ></Navigator>
    </React.Fragment>
  );
};

export default AccountDefinitionView;
